type InjectScriptOptions = {
  parentElement?: Element;
  // @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement
  additionalScriptAttributes?: {
    id?: string;
    class?: string;
    async?: boolean;
    crossOrigin?: boolean;
    type?: string;
    nonce?: string;
    noModule?: boolean;
    defer?: boolean;
    referrerPolicy?: string;
  };
  shouldInjectIfAlreadyPresent?: (src: string) => boolean;
};

export const injectScript = (
  src: string,
  options?: Partial<InjectScriptOptions>,
): Promise<string> => {
  return new Promise((resolve, reject) => {
    const existingScript = document.querySelector(`script[src="${src}"]`);
    const parentHtmlElement = options?.parentElement ?? document.head;
    const shouldInjectIfAlreadyPresent = options?.shouldInjectIfAlreadyPresent;

    if (
      existingScript &&
      shouldInjectIfAlreadyPresent &&
      !shouldInjectIfAlreadyPresent(src)
    ) {
      resolve('already-injected');
      return;
    }

    // Note that injected scripts are by default async
    const newScript = document.createElement('script');

    newScript.src = src;

    if (options?.additionalScriptAttributes) {
      const entries = Object.entries(options.additionalScriptAttributes);

      for (let i = 0, len = entries.length; i < len; i++) {
        const [key, val] = entries[i];
        const typeOfVal = typeof val;

        if (typeOfVal === 'string' || typeOfVal === 'number') {
          newScript.setAttribute(key, val + '');
        } else if (typeOfVal === 'boolean' && val) {
          newScript.setAttribute(key, key);
        }
      }
    }

    newScript.onload = () => resolve(new Date().toISOString());
    newScript.onerror = reject;

    parentHtmlElement.appendChild(newScript);
  });
};
